import { render, staticRenderFns } from "./RecommendationsBlock.vue?vue&type=template&id=4c02bd91&"
import script from "./RecommendationsBlock.vue?vue&type=script&lang=js&"
export * from "./RecommendationsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports